export default __webpack_public_path__ + "static/media/ajuda-imagem.d97c485b.png";